import { Store, Common } from 'interfaces';

export default function updateAvailability(
  state: Store.State,
  availability: Common.Availability,
  startTime?: string
) {
  state.availability = availability;
  state.startTime = startTime;
}
